import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface UserAddIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const UserAddIcon: React.FC<UserAddIconProps> = ({
  size = 20,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        d="M14.1566 16.1406C14.2955 16.4308 14.2818 16.776 14.1202 17.0529C13.9587 17.3299 13.6723 17.499 13.3635 17.5H0.888384C0.579542 17.499 0.293206 17.3299 0.131646 17.0529C-0.0299141 16.776 -0.043658 16.4308 0.095323 16.1406L1.37848 13.4313C1.83186 12.4758 2.76045 11.8729 3.77548 11.875H10.4764C11.4914 11.8729 12.42 12.4758 12.8734 13.4313L14.1566 16.1406ZM7.12594 10C9.09446 10 10.6903 8.32107 10.6903 6.25C10.6903 4.17893 9.09446 2.5 7.12594 2.5C5.15742 2.5 3.56162 4.17893 3.56162 6.25C3.56162 8.32107 5.15742 10 7.12594 10ZM19.5545 7.52227H17.3268V5.17852C17.3268 4.91963 17.1273 4.70977 16.8812 4.70977H15.9901C15.7441 4.70977 15.5446 4.91963 15.5446 5.17852V7.52227H13.3169C13.0708 7.52227 12.8714 7.73213 12.8714 7.99102V8.92852C12.8714 9.1874 13.0708 9.39727 13.3169 9.39727H15.5446V11.741C15.5446 11.9999 15.7441 12.2098 15.9901 12.2098H16.8812C17.1273 12.2098 17.3268 11.9999 17.3268 11.741V9.39727H19.5545C19.8005 9.39727 20 9.1874 20 8.92852V7.99102C20 7.73213 19.8005 7.52227 19.5545 7.52227Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

UserAddIcon.displayName = 'UserAddIcon';

export { UserAddIcon };
